"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.regexp.split");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _ramda = require("ramda");

var _StyledSettingsComponents = require("./StyledSettingsComponents");

var _Input = _interopRequireDefault(require("./Input"));

var _Select = _interopRequireDefault(require("./Select"));

var _Textarea = _interopRequireDefault(require("./Textarea"));

var _fonts = require("../../constants/fonts");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _withCurrentContext = _interopRequireDefault(require("../hocs/withCurrentContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    font-size: 12px;\n    cursor: pointer;\n    transition: all .3s;\n    &:hover {\n        color: black;\n    }\n    &:not(:last-of-type) {\n        margin-right: 7px;\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 10px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Row = _styledComponents.default.div(_templateObject());

var FontStyleRow = (0, _styledComponents.default)(Row)(_templateObject2());
var TextStyleIcon = (0, _styledComponents.default)(_reactFontawesome.FontAwesomeIcon)(_templateObject3());

var TextPanel =
/*#__PURE__*/
function (_Component) {
  _inherits(TextPanel, _Component);

  function TextPanel() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TextPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextPanel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onChangeAlign = function (align) {
      var onChangeProp = _this.props.onChangeProp;
      onChangeProp('align', align);
    };

    _this.onChangeFontStyle = function (style) {
      var _this$props = _this.props,
          current = _this$props.current,
          onChangeProp = _this$props.onChangeProp;
      var styles = (current.fontStyle || '').split(' ');
      var updated = (0, _ramda.contains)(style, styles) ? (0, _ramda.without)([style], styles) : (0, _ramda.append)(style, styles);
      updated = !updated.length ? ['normal'] : (0, _ramda.contains)('normal', updated) && updated.length > 1 ? (0, _ramda.without)(['normal'], updated) : updated;
      onChangeProp('fontStyle', updated.join(' '));
    };

    _this.onChangeTextDecoration = function (decoration) {
      var _this$props2 = _this.props,
          current = _this$props2.current,
          onChangeProp = _this$props2.onChangeProp;
      var decorations = (current.textDecoration || '').split(' ');
      var updated = (0, _ramda.contains)(decoration, decorations) ? (0, _ramda.without)([decoration], decorations) : (0, _ramda.append)(decoration, decorations);
      onChangeProp('textDecoration', updated.join(' '));
    };

    _this.isAlignActive = function (v) {
      return (0, _ramda.equals)(v, _this.props.current.align);
    };

    _this.isFontStyleActive = function (v) {
      return (0, _ramda.contains)(v, _this.props.current.fontStyle || '');
    };

    _this.isTextDecorationActive = function (v) {
      return (0, _ramda.contains)(v, _this.props.current.textDecoration || '');
    };

    _this.stylesList = [{
      icon: _freeSolidSvgIcons.faAlignLeft,
      value: 'left',
      onChange: _this.onChangeAlign,
      isActive: _this.isAlignActive
    }, {
      icon: _freeSolidSvgIcons.faAlignCenter,
      value: 'center',
      onChange: _this.onChangeAlign,
      isActive: _this.isAlignActive
    }, {
      icon: _freeSolidSvgIcons.faAlignRight,
      value: 'right',
      onChange: _this.onChangeAlign,
      isActive: _this.isAlignActive
    }, {
      icon: _freeSolidSvgIcons.faBold,
      value: 'bold',
      onChange: _this.onChangeFontStyle,
      isActive: _this.isFontStyleActive
    }, {
      icon: _freeSolidSvgIcons.faItalic,
      value: 'italic',
      onChange: _this.onChangeFontStyle,
      isActive: _this.isFontStyleActive
    }, {
      icon: _freeSolidSvgIcons.faUnderline,
      value: 'underline',
      onChange: _this.onChangeTextDecoration,
      isActive: _this.isTextDecorationActive
    }, {
      icon: _freeSolidSvgIcons.faStrikethrough,
      value: 'line-through',
      onChange: _this.onChangeTextDecoration,
      isActive: _this.isTextDecorationActive
    }];

    _this.renderTextStylePanel = function () {
      return _react.default.createElement("div", null, _this.stylesList.map(function (_ref) {
        var icon = _ref.icon,
            value = _ref.value,
            onChange = _ref.onChange,
            isActive = _ref.isActive;
        return _react.default.createElement(TextStyleIcon, {
          key: value,
          color: isActive(value) ? 'black' : 'rgb(181, 181, 181)',
          icon: icon,
          onClick: function onClick() {
            return onChange(value);
          }
        });
      }));
    };

    return _this;
  }

  _createClass(TextPanel, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_StyledSettingsComponents.Panel, null, _react.default.createElement(FontStyleRow, null, _react.default.createElement(_Input.default, {
        prop: "fontSize",
        small: "\u0440\u0430\u0437\u043C\u0435\u0440 \u0448\u0440\u0438\u0444\u0442\u0430",
        isNumber: true
      }), this.renderTextStylePanel()), _react.default.createElement(Row, null, _react.default.createElement(_Select.default, {
        small: "\u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0440\u0438\u0444\u0442",
        prop: "fontFamily",
        options: _fonts.FONTS
      })), _react.default.createElement(_Textarea.default, {
        prop: "text"
      }));
    }
  }]);

  return TextPanel;
}(_react.Component);

TextPanel.propTypes = {
  onChangeProp: _propTypes.default.func,
  current: _propTypes.default.object
};

var _default = (0, _withCurrentContext.default)(TextPanel);

exports.default = _default;